import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { getGroup } from '../../../../../../stores/groups/groups.selectors'
import { deleteGroup } from '../../../../../../stores/groups/groups.actions'
import { openUpdateGroupDialog } from '../../../dialogs/update-group/update-group.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { id }) => {
  const group = getGroup(state, id)
  return {
    groupName: group.title,
    mis: group.mis_group,
    canEdit: group.policy && group.policy.can_manage_students_for_group
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onDelete: () => dispatch(deleteGroup(ownProps.id)).catch(errorHandler),
  onEdit: () => dispatch(openUpdateGroupDialog(ownProps.id))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContextMenu)
